module.exports = __webpack_public_path__ + "static/src/content/images/processed/thumbBlurLarge/shoals.a6c3914.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/content/images/processed/thumbBlurLarge/shoals.jpg
// module id = ZhVt
// module chunks = 0